(function(){
  'use strict';

  function initSticky(sticky) {
    if (!sticky || sticky.dataset.ecloDiagnosticReady === 'true') return;
    var triggerId = sticky.getAttribute('data-trigger-id');
    var trigger = triggerId ? document.getElementById(triggerId) : null;
    if (!trigger) return;

    var triggerVisible = true;

    function render() {
      var shouldShow = !triggerVisible && window.scrollY >= 300;
      sticky.hidden = !shouldShow;
      document.documentElement.classList.toggle('eclo-diagnostic-sticky-visible', shouldShow);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries){
        if (!entries || !entries.length) return;
        triggerVisible = entries[0].isIntersecting;
        render();
      }, { threshold: 0.08 });
      observer.observe(trigger);
    } else {
      function fallbackCheck(){
        var rect = trigger.getBoundingClientRect();
        triggerVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        render();
      }
      window.addEventListener('scroll', fallbackCheck, { passive:true });
      window.addEventListener('resize', fallbackCheck);
      fallbackCheck();
    }

    window.addEventListener('scroll', render, { passive:true });
    window.addEventListener('pageshow', render);
    sticky.dataset.ecloDiagnosticReady = 'true';
  }

  function init(scope){
    (scope || document).querySelectorAll('[data-eclo-diagnostic-sticky]').forEach(initSticky);
  }

  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(event){ init(event.target || document); });
})();
